import { memo } from 'react';

const JoinScreen = ({ updateMeetingId, getMeetingAndToken }) => {
  return (
    <div
      style={{
        height: '100vh',
        justifyContent: 'center',
        alignItems: 'center',
        display: 'flex',
      }}
    >
      <input
        type="text"
        placeholder="Enter Meeting Id"
        onChange={(e) => {
          updateMeetingId(e.target.value);
        }}
      />
      <button onClick={getMeetingAndToken}>Join</button>
      <button onClick={getMeetingAndToken}>Create Meeting</button>
    </div>
  );
};

export default memo(JoinScreen);
